import script from "./BaseRadio.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseRadio.vue?vue&type=script&lang=ts&setup=true"

import "./BaseRadio.vue?vue&type=style&index=0&id=77624292&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77624292"]])

export default __exports__